import { Body1, Button, Link } from '@cian/ui-kit';

import * as styles from './Phone.css';

interface IProps {
  formattedPhone: string;
  hiddenPhone: string;
  isPhoneMinimized: boolean;
  onPhoneClick(): void;
}

export const Phone = ({ formattedPhone, hiddenPhone, isPhoneMinimized, onPhoneClick }: IProps) => {
  return (
    <div data-name="Phone" className={styles['container']}>
      {isPhoneMinimized ? (
        <div className={styles['row']}>
          <Body1>{hiddenPhone}</Body1>
          <Button theme="fill_secondary" size="XS" onClick={onPhoneClick}>
            Показать
          </Button>
        </div>
      ) : (
        <Link fontSize="M" href={`tel:${formattedPhone}`} data-name="OpenPhone">
          {formattedPhone}
        </Link>
      )}
    </div>
  );
};
